var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('feather-icon',{staticClass:"mr-50 section-status-icon",class:_vm.iconClass,attrs:{"icon":_vm.iconName,"size":"16"}})}
var staticRenderFns = []

export { render, staticRenderFns }